import { edmCampaign } from '@bingads-webui/edm-campaign';

const adEDM = edmCampaign.types.resolve('Model.ResponsiveAd');
const adResource = new adEDM.ResourceIdentifier();

export const createOrUpdateAd = (data, skipApiCall = false) => {
  if (skipApiCall) {
    return Promise.resolve({ Id: -1 });
  }

  const createOrUpdateCall = data && data.Id ?
    adResource.bulkUpdate.bind(adResource) :
    adResource.bulkCreate.bind(adResource);

  return createOrUpdateCall(data);
};

export const readAd = (cid, aid, campaignId, adGroupId, adId) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .Campaigns.$withKey(campaignId)
  .AdGroups.$withKey(adGroupId)
  .Ads.$withKey(adId)
  .get({
    select: [
      'Id',
      'FinalUrls',
      'Headline',
      'Text',
      'Model.ResponsiveAd/Images',
      'CallToAction',
    ],
  }).toPromise();
